import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Typography, CircularProgress,
  InputAdornment, IconButton, makeStyles,
} from "@material-ui/core";
import LockIcon from "@material-ui/icons/Lock";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles((theme) => ({
  dialogPaper: { borderRadius: 16, padding: theme.spacing(1), maxWidth: 440 },
  lockIcon: {
    display: "flex", justifyContent: "center", marginBottom: theme.spacing(1),
    "& svg": { fontSize: 48, color: theme.palette.primary.main },
  },
  subtitle: {
    textAlign: "center", color: theme.palette.text.secondary, fontSize: 14,
    marginBottom: theme.spacing(2), padding: theme.spacing(0, 2),
  },
  field: { marginBottom: theme.spacing(2) },
  actions: { padding: theme.spacing(2), paddingTop: 0 },
  saveButton: { borderRadius: 30, fontWeight: 700, textTransform: "none", padding: "10px 32px" },
}));

const PasswordChangeModal = ({ open, userId, onSuccess }) => {
  const classes = useStyles();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    if (newPassword.length < 5) { toast.warn("A senha deve ter pelo menos 5 caracteres."); return; }
    if (newPassword !== confirmPassword) { toast.warn("As senhas nao coincidem."); return; }
    if (newPassword === "mudar123") { toast.warn("Escolha uma senha diferente da senha padrao."); return; }
    setLoading(true);
    try {
      await api.put(`/users/${userId}`, { password: newPassword });
      toast.success("Senha alterada com sucesso!");
      setNewPassword(""); setConfirmPassword("");
      onSuccess();
    } catch (err) { toastError(err); }
    finally { setLoading(false); }
  };

  return (
    <Dialog open={open} disableBackdropClick disableEscapeKeyDown
      PaperProps={{ className: classes.dialogPaper }} maxWidth="xs" fullWidth>
      <DialogTitle disableTypography>
        <div className={classes.lockIcon}><LockIcon /></div>
        <Typography variant="h6" style={{ fontWeight: 700, textAlign: "center" }}>Troque sua senha</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography className={classes.subtitle}>
          Sua senha foi redefinida pelo administrador. Por seguranca, crie uma nova senha para continuar.
        </Typography>
        <TextField className={classes.field} label="Nova senha" type={showNew ? "text" : "password"}
          value={newPassword} onChange={(e) => setNewPassword(e.target.value)}
          variant="outlined" fullWidth autoFocus inputProps={{ minLength: 5 }}
          InputProps={{ endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => setShowNew((v) => !v)} size="small">
                {showNew ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          )}} />
        <TextField className={classes.field} label="Confirmar nova senha" type={showConfirm ? "text" : "password"}
          value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}
          variant="outlined" fullWidth inputProps={{ minLength: 5 }}
          onKeyPress={(e) => { if (e.key === "Enter") handleSave(); }}
          InputProps={{ endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => setShowConfirm((v) => !v)} size="small">
                {showConfirm ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          )}} />
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button className={classes.saveButton} variant="contained" color="primary"
          onClick={handleSave} disabled={loading} fullWidth>
          {loading ? <CircularProgress size={22} color="inherit" /> : "Salvar nova senha"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PasswordChangeModal;
